'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextInput from 'Components/Forms/Elements/TextInput';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { front_urls, URL, action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
const DEFAULT_ERROR = 'Connexion impossible, veuillez rententer ' + 'ultérieurement.';
export default class CompanyLoginForm extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.form_error) {
      component.setState({
        error: app.state.form_error
      });
    }
  }
  login = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    e.persist();
    component.setState({
      loading: true
    });
    qwest.post(action('log-company'), {
      login: state.email,
      pack_code: state.pack_code
    }).then(function (xhr, response) {
      app.emit({
        event: 'TC_Click',
        source: 'LoginForm',
        data: {
          e: undefined,
          action: 'connexion'
        }
      });

      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      app.navigateTo('/');
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response,
          error: DEFAULT_ERROR
        }),
        loading: false
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/company-login",
      className: "login-page__form",
      onSubmit: component.login
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['email'],
      name: "email",
      label: "E-mail",
      type: "email",
      autocomplete: "current-email",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['pack_code'],
      name: "pack_code",
      label: "Code du pack",
      className: "u-margin-top-10",
      status: state.status_messages
    }), status, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-25 u-text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: bemit('c-flat-btn', ['front', 'blue', 'front-search'])
    }, "Je me connecte", loader)));
    return output;
  }
}
